import React from 'react'
import { Box } from 'chemistry'
import { clsx } from 'clsx'

const DeliveryModeLabel = ({ deliveryMode, isStuckBottom }) => {
  if (!deliveryMode) return null

  return (
    <Box
      className={clsx('mxd-promotion-label', {
        'mxd-promotion-label-stuck-bottom': isStuckBottom
      })}
      display='inline-block'
      p='8px 16px'
      backgroundColor='var(--chakra-colors-black-black)'
      color='var(--chakra-colors-white-0)'
      lineHeight='1.5714285714'
      fontFamily='RubrikNew-Bold,Ubuntu,sans-serif'
      letterSpacing='.1px'
      textTransform='uppercase'
    >
      {deliveryMode}
    </Box>
  )
}

export default DeliveryModeLabel
